/* eslint-disable no-undef */
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import store, { persistor } from './redux/store';
import * as _redux from './redux';
import * as Sentry from '@sentry/react';
import axios from 'axios';
import 'dotenv/config';
import './assets/css/lato.css';
import './assets/css/roboto.css';
import './assets/css/global.css';
import './assets/css/animate.min.css';
import { UPIRIA_ASCII_ART } from './config';

const { PUBLIC_URL } = process.env;

{
	//ENVIRONMENT === 'production' ?
	_redux.setupAxios(axios, store); //:
	//_redux.mockAxios(axios)
}

console.log(UPIRIA_ASCII_ART);

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,

	// This sets the sample rate to be 10%. You may want this to be 100% while
	// in development and sample at a lower rate in production
	replaysSessionSampleRate: 0.1,

	// If the entire session is not sampled, use the below sample rate to sample
	// sessions when an error occurs.
	replaysOnErrorSampleRate: 1.0,

	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.breadcrumbsIntegration({
			console: true,
			dom: true,
			fetch: true,
			history: true,
			xhr: true,
		}),
		Sentry.browserApiErrorsIntegration({
			setTimeout: true,
			setInterval: true,
			requestAnimationFrame: true,
			XMLHttpRequest: true,
			eventTarget: true,
		}),
		Sentry.captureConsoleIntegration({ levels: ['error', 'warn'] }),
		Sentry.contextLinesIntegration(),
		Sentry.dedupeIntegration(),
		Sentry.extraErrorDataIntegration(),
		Sentry.httpClientIntegration(),
		Sentry.sessionTimingIntegration(),
		Sentry.replayIntegration(),
	],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for tracing.
	tracesSampleRate: 1.0,

	// Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled https://
	// tracePropagationTargets: ['localhost', /^https:\/\/upiria\.com/, /^https:\/\/upiria\.com/, /^https:\/\/dev.upiria\.com/,],
	tracePropagationTargets: ['localhost', 'https://portal.upiria.com', 'https://dev-portal.upiria.com', process.env.REACT_APP_SCHEME + process.env.REACT_APP_API_HOST],

	// This option is required for capturing headers and cookies.
	sendDefaultPii: true,

	environment: process.env.REACT_APP_ENV,
});

ReactDOM.render(
	<App store={store} persistor={persistor} basename={PUBLIC_URL} />,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
